const _ = require('underscore');
const Actions = require('common/domain/action/index');
const GroupAction = require('common/domain/action/group');
const GroupModel = require('common/domain/entity/group');
const GroupCollection = require('common/domain/collection/group');
const Dispatcher = require('common/domain/repository/dispatcher');
const Backbone = require('backbone');

var GroupStore = Backbone.Model.extend({
    initialize: function() {
        _.bindAll(this, 'dispatch');
        this._groups = new GroupCollection();
        Dispatcher.register(this.dispatch);
    },

    getGroups: function() {
        return this._groups;
    },

    getGroup: function(groupId) {
        return new Promise((resolve, reject) => {
            const group = this._groups.get(groupId);
            // Member が 0 の場合は一覧取得のための Group なので再取得が必要
            if(group && group.getMembers().length > 0) {
                resolve(group);
            } else {
                GroupAction.fetchGroupOnce(groupId).then(() => {
                    resolve(this._groups.get(groupId));
                }, reject);
            }
        });
    },

    clearAll: function() {
        this._groups = new GroupCollection;
    },

    dispatch: function(action) {
        switch(action.type) {
            case Actions.CREATE_GROUP:
                this._createGroup(action);
                break;
            case Actions.UPDATE_GROUP:
                this._updateGroup(action);
                break;
            case Actions.DELETE_GROUP:
                this._deleteGroup(action);
                break;
        }
    },

    add: function(groupJson) {
        Dispatcher.dispatch({
            type: Actions.CREATE_GROUP,
            group: groupJson
        });
    },

    _createGroup: function(action) {
        var groups = this._groups;
        const gs = _.isArray(action.group) ?
            action.group : [action.group];
        const m = _.map(gs, function(g) {
            return new GroupModel(g);
        });
        groups.add(m, {merge: true});
    },

    _updateGroup: function(action) {
        var groups = this._groups;
        var p = groups.get(action.group.id);
        if(!p) {
            return;
        }
        p.set(action.group);
    },

    _deleteGroup: function(action) {
        var groups = this._groups;
        var p = groups.get(action.group.id);
        if(!p) {
            return;
        }
        groups.remove(p);
    }
});

module.exports = new GroupStore();



// WEBPACK FOOTER //
// ./common/domain/repository/group.js